export const state = {
	userCompany: {},
	currentUser: {},
	companies: [],
};
